import { CommonFilterParams, Filter, FilterOperators, FilterTypes } from '@va/types/filters';
import { PickerConfig } from '@va/ui/design-system';
import dayjs, { Dayjs } from 'dayjs';
import { DateFilterApplied } from './DateFilterApplied';
import { DateFilterInput } from './DateFilterInput';

/** Dates are kept as `YYYY-MM-DD` strings so the filter can be persisted and restored as plain JSON. */
export type DateFilterValue = { start: string; end: string };

export const DATE_FILTER_VALUE_FORMAT = 'YYYY-MM-DD';

export const parseDateFilterValue = (value: string | undefined) => (value ? dayjs(value) : undefined);

export type DateFilterInputProps = {
  startLabel: string;
  endLabel: string;
  pickerConfig?: PickerConfig;
  /** Pre-fills the end date when a new filter is added. */
  defaultEnd?: Dayjs;
};

type DateFilterParams = CommonFilterParams<DateFilterValue, DateFilterInputProps>;

export class DateFilter extends Filter<DateFilterValue, DateFilterInputProps> {
  constructor(params: DateFilterParams) {
    super({
      ...params,
      operator: params.operator || FilterOperators.between,
      input: DateFilterInput,
      appliedInput: DateFilterApplied,
      type: FilterTypes.Date,
    });
  }
}
